






import Vue from 'vue';

import { GridApi } from '@ag-grid-enterprise/all-modules';
export default Vue.extend({
    data: () => null,
    props: { toggleAllCheckboxBtn: Function },
    methods: {
        toggleAll(e): void {
            this.params.toggleAllCheckboxBtn();

            // select / deselect current page only
            const from =
                this.params.api.paginationGetCurrentPage() *
                this.params.api.paginationGetPageSize();
            const to =
                (this.params.api.paginationGetCurrentPage() + 1) *
                this.params.api.paginationGetPageSize();

            let hasSelected = false;
            this.params.api.forEachNode(node => {
                const ix = node.rowIndex;
                if (ix >= from && ix < to && node.isSelected()) {
                    hasSelected = true;
                }
            });
            this.params.api.forEachNode(node => {
                const ix = node.rowIndex;
                if (ix >= from && ix < to) {
                    node.setSelected(!hasSelected);
                }
            });
        },
    },
});
